module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAABCUlEQVRIie2V0U3EMBBEXxD/0AF0QOiAEihgJHIdXAcclRCULYASrgOODqADrgLfB05kOXYSogQJiZFWiu3RPO8qkgvnHGvqbNX0XweY2eLzWr2D8ykmMyuBPbCVVGc8l8BeUhnuj3YQhF8Az2a2y3g+gJv4bBDgb/Xqw1s9mlkdeCrgLfJ0yo6obRm4Shw/mFn3PXTJJCAI77UcQoaCW/VGNDF8snodSPoCyoR3GQCAmR2Y2YGkIlzn/qI74H0OIFYS4Mc0Bnnx9XNABPlMhUuqJFXAZhYggNwDx2D7yQe3nhq4jTzTAD7gwHcnR2AjaZfxXJMaqXOuq6ZpXLheov7+i1b8P/pjOgFiiJokJTb8vAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_area_mirror_grey.png
// module id = 338
// module chunks = 1